module.exports = __webpack_public_path__ + "static/img/s98.6583942c.png";